// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ Import this

const firebaseConfig = {
  apiKey: "AIzaSyBELVhTt1VtjNCAwsQICyECq234feFqbjM",
  authDomain: "bodhai-a4022.firebaseapp.com",
  databaseURL: "https://bodhai-a4022-default-rtdb.firebaseio.com",
  projectId: "bodhai-a4022",
  storageBucket: "bodhai-a4022.appspot.com", // ✅ FIXED: must end in .app**spot**.com
  messagingSenderId: "158976010022",
  appId: "1:158976010022:web:3a206a27d4e43d1c3703e7",
  measurementId: "G-Y48PJGR2N5"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getDatabase(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app); // ✅ Export storage
